class LocationField {
    constructor(el = null) {
        this.el = el;

        if(this.el) {
            this.init();
            this.waitForGMapLibrary();
        }
    }

    init() {
        this.addressInput = this.el.querySelector('.location-field__address-input');
        this.distanceSelect = this.el.querySelector('.location-field__distance-select');
        this.latitudeField = this.el.querySelector('.location-field__lat-coordinate');
        this.longitudeField = this.el.querySelector('.location-field__lng-coordinate');

        this.initialized = false;
        this.autocomplete = null;
        this.isPrefilled = !!this.addressInput.value;
        this.isUserValue = !this.isPrefilled;

        console.log('this.isPrefilled', this.isPrefilled);
    }

    bindEvents() {
        if(this.addressInput && this.autocomplete) {
            this.onKeyUpFn = this.onKeyUp.bind(this);
            this.onBlurFn = this.onBlur.bind(this);
            this.onPlaceChangeFn = this.onPlaceChange.bind(this);

            this.addressInput.addEventListener('blur', this.onBlurFn);
            this.addressInput.addEventListener('keyup', this.onKeyUpFn);
            this.autocomplete.addListener('place_changed', this.onPlaceChangeFn);
        }
    }

    waitForGMapLibrary() {
        if(typeof google !== 'undefined' && typeof google?.maps?.places?.Autocomplete !== 'undefined') {
            this.onGMapLibraryLoaded();
        }
        else {
            this.onGMapLibraryLoadedFn = this.onGMapLibraryLoaded.bind(this);
            document.addEventListener('gmap-library:loaded', this.onGMapLibraryLoadedFn);
        }
    }

    onGMapLibraryLoaded() {
        if(this.initialized || !this.addressInput) {
            return;
        }

        if(this?.onGMapLibraryLoadedFn) {
            document.removeEventListener('gmap-library:loaded', this.onGMapLibraryLoadedFn);
        }

        this.initialized = true;
        
        const options = {
            componentRestrictions: { country: 'fr' },
            fields: ['geometry', 'name'],
            strictBounds: false
        };
        
        this.autocomplete = new google.maps.places.Autocomplete(this.addressInput, options);

        this.bindEvents();
    }

    onPlaceChange() {
        if(this.addressInput.value) {
            const placeResult = this.autocomplete.getPlace();
            
            if(placeResult && placeResult?.geometry?.location?.lat && placeResult?.geometry?.location?.lng) {
                this.latitudeField.value = placeResult.geometry.location.lat();
                this.longitudeField.value = placeResult.geometry.location.lng();
                this.isUserValue = false;
            }
            else {
                this.reset();
            }
        }
    }

    onKeyUp(e) {
        this.isUserValue = true;
    }

    onBlur(e) {
        if(this.isUserValue) {
            this.reset();
        }
    }

    getLocation() {
        return {lat: parseFloat(this.latitudeField.value), lng: parseFloat(this.longitudeField.value)};
    }

    isValid() {
        return this.addressInput.value && this.latitudeField.value && this.longitudeField.value && !isNaN(parseFloat(this.latitudeField.value)) && !isNaN(parseFloat(this.longitudeField.value));
    }

    reset() {
        this.addressInput.value = '';
        this.latitudeField.value = '';
        this.longitudeField.value = '';
    }
}

export default LocationField;